import { Button } from "@/components/ui/button";
import { SubMenuItemsType } from "@/types/menu";
import { cn } from "@/lib/utils";
import Image from '@/components/ui/Image';
import Link from "next/link";

export const FeatureImageItem = ({ items, className }: { items: SubMenuItemsType, className?: string }) => {
  if (!items?.items || items.items.length === 0) return null;

  return (
    <>
      {items.items.map((item, index) => (
        <div key={index} className={cn("relative flex flex-col gap-y-1", className)}>
          {item?.link ? (
            <Link href={item.link}>
              {item?.hasImage && item?.image && (
                <div className="flex-1 pb-6">
                  <div className="relative h-full w-full origin-bottom transition duration-300 group-hover/featureImageItem:scale-105">
                    <Image
                      src={item?.image ?? ""}
                      alt={item?.title ?? ""}
                      width={768}
                      height={432}
                      className="h-full w-full object-cover object-center rounded-lg"
                    />
                  </div>
                </div>
              )}
              {item?.title && (
                <div className="paragraph-lg font-bold">{item?.title}</div>
              )}
              {item?.subtitle && (
                <span className="paragraph-base text-muted-foreground">{item?.subtitle}</span>
              )}
            </Link>
          ) : (
            <>
              {item?.hasImage && item?.image && (
                <div className="flex-1 pb-6">
                  <div className="relative h-full w-full origin-bottom transition duration-300 group-hover/featureImageItem:scale-105">
                    <Image
                      src={item?.image ?? ""}
                      alt={item?.title ?? ""}
                      width={768}
                      height={432}
                      className="h-full w-full object-cover object-center rounded-lg"
                    />
                  </div>
                </div>
              )}
              {item?.title && (
                <div className="paragraph-lg font-bold">{item?.title}</div>
              )}
              {item?.subtitle && (
                <span className="paragraph-base text-muted-foreground">{item?.subtitle}</span>
              )}
            </>
          )}
          {item?.hasButton && item?.buttonText && (
            <div>
              <Button asChild variant={item?.buttonStyle} size="sm">
                <a href={item?.link || "/"} className="inline-flex mt-4">
                  {item?.buttonText}
                  {/* <span className="material-symbols-outlined w-4.5 h-4.5" style={{ fontSize: '18px' }}>
                    arrow_forward
                  </span> */}
                </a>
              </Button>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

FeatureImageItem.displayName = 'NavFeatureImageItem'; 